/**
 * A corner filler BODY of any convex outline — the shape the corner filler
 * an angled wall corner gets (`buildCornerFillCountertop`'s cabinet), so the
 * plan, the 3D view, the elevations, the estimate and the collision check
 * (`collision/geometry.getObjectCorners`) read it the same way. Used where a
 * bend's filler is not the generator's kite: the wedge at a bend away from
 * the cabinets (`outsideBend.js`), and a bend toward them where the deeper
 * leg runs to the vertex (`corners.buildObliqueKite`, a zero stop).
 *
 * Pure. No I/O.
 */

/**
 * @param {{ id:string, polygon:Array<{x,z}>, floorY:number, height:number,
 *   runId:string, cornerIndex:number }} a
 * @returns {Object|null} a `corner-fill-cabinet`, null without an outline
 */
function buildPolygonFiller({
  id,
  polygon,
  floorY,
  height,
  runId,
  cornerIndex,
}) {
  if (!polygon || polygon.length < 3) return null;
  const xs = polygon.map((p) => p.x);
  const zs = polygon.map((p) => p.z);
  const minX = Math.min(...xs);
  const maxX = Math.max(...xs);
  const minZ = Math.min(...zs);
  const maxZ = Math.max(...zs);
  return {
    id,
    type: 'corner-fill-cabinet',
    label: 'Corner-Fill Cabinet',
    category: {
      cabinet: true,
      'lower-cabinet': true,
      'corner-fill-cabinet': true,
    },
    center: {
      x: (minX + maxX) / 2,
      y: floorY + height / 2,
      z: (minZ + maxZ) / 2,
    },
    dimensions: { x: maxX - minX, y: height, z: maxZ - minZ },
    rotation: { x: 0, y: 0, z: 0 },
    polygonCorners: polygon.map((p) => ({ x: p.x, z: p.z })),
    addedBy: 'manual-cabinet-run',
    runId,
    cornerIndex,
  };
}

module.exports = { buildPolygonFiller };
